import kebabCase from 'lodash/kebabCase';
import toLower from 'lodash/toLower';

export const nameToUrl = name => kebabCase(
    toLower(name).replace(/\.|'/g, '')
);


export const buildProfileUrl = (id, name, type) =>
    `/profile/${type}/${id}/${nameToUrl(name)}`;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/utils/url.js